import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DmsService {

    constructor(private http: HttpClient) { }

    getDocumentData(){
        return this.http.get('http://localhost:4200/api/documents');
    }
    addDocumentCopy(checkedItems){
  return this.http.get('http://localhost:4200/api/documentsCopy');
    }

}